<input #textInput type="text" class="form-control form-control-sm p-0 customboxTextFieldValue"
    [value]="value" [readonly]="readOnly" (blur)="updateTextFieldValue($event)"
    (keyup.enter)="updateTextFieldValue($event)" placeholder="Add value" aria-label="add value" />